const DashboardType = Object.freeze({
  DASHBOARD: 'DASHBOARD',
  TEMPLATE: 'TEMPLATE',
  ANALYSIS: 'ANALYSIS'
})
export default DashboardType
// RESERVE BELOW
